import React, { useRef, useState, useMemo } from "react";
import DownloadExcel from "../../../../Extra/DownloadExcel";

const tableHead = [
  "Sno",
  "Date",
  "Type",
  "From Station",
  "To Station",
  "Reason",
  "Path Wastage",
  "Remark",
];

const DayWisePath = ({
  data,
  totalKeys = ["PT_WASTAGE_TRAIN_TYPE", "PT_WASTAGE_NUM"],
}) => {
  const tableRef = useRef();

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 20;

  const totalPages = Math.ceil(data?.length / rowsPerPage || 1);

  const currentData = useMemo(() => {
    if (!data) return [];
    const start = (currentPage - 1) * rowsPerPage;
    const end = start + rowsPerPage;
    return data.slice(start, end);
  }, [data, currentPage]);

  // Compute totals: string keys -> counts, numeric keys -> sum
  const totals = useMemo(() => {
    const result = {};
    totalKeys.forEach((key) => {
      result[key] = {};
      data.forEach((row) => {
        const value = row[key];
        if (!isNaN(value) && value !== null && value !== undefined) {
          // numeric -> sum
          result[key].sum = (result[key].sum || 0) + Number(value);
        } else {
          // string -> count occurrences
          const valStr = value || "Normal";
          result[key][valStr] = (result[key][valStr] || 0) + 1;
        }
      });
    });
    return result;
  }, [data, totalKeys]);

  const handlePrev = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNext = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));

  return (
    <div>
      <div className="papaDiv">
        <div className="mb-1 bg-dark text-white p-1">
          <h5 className="">Day wise Path Wastage</h5>
          <h6 style={{ color: "rgba(187, 187, 187, 1)", fontWeight: "bold" }}>
            (count {data.length})
          </h6>
        </div>

        <div className="table-responsive">
          <table
            className="table table-hover table-strip"
            ref={tableRef}
            style={{ zIndex: 2 }}
          >
            <thead className="sticky-top align-middle" style={{ zIndex: 2 }}>
              <tr className="table-dark">
                {tableHead.map((head, index) => (
                  <th
                    rowSpan={head === "Path Wastage" ? 1 : 2}
                    colSpan={head === "Path Wastage" ? 2 : 1}
                    key={index}
                  >
                    {head}
                  </th>
                ))}
              </tr>
              <tr className="table-dark">
                <th>No</th>
                <th>Train</th>
              </tr>
            </thead>
            <tbody>
              {currentData.map((obj, i) => (
                <tr key={i}>
                  <td>{(currentPage - 1) * rowsPerPage + i + 1}</td>
                  <td>{obj.PT_DATE?.slice(0, 10)}</td>
                  <td>{obj.PT_TYPE}</td>
                  <td>{obj.PT_FROM}</td>
                  <td>{obj.PT_TO}</td>
                  <td>{obj.PT_REASON}</td>
                  <td>{obj.PT_WASTAGE_NUM}</td>
                  <td>{obj.PT_WASTAGE_TRAIN_TYPE}</td>
                  <td>{obj.REMARK}</td>
                </tr>
              ))}

              {/* Totals row */}
              <tr className="table-secondary font-weight-bold">
                <td colSpan={6} style={{ textAlign: "right" }}>
                  Total
                </td>
                <td>{totals["PT_WASTAGE_NUM"]?.sum || 0}</td>
                <td>
                  {Object.entries(totals["PT_WASTAGE_TRAIN_TYPE"] || {})
                    .filter(([k]) => k !== "sum")
                    .map(([val, count]) => `${val}: ${count}`)
                    .join(", ")}
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Pagination buttons */}
        <div className="d-flex justify-content-between align-items-center mt-2">
          <button
            className="btn btn-sm btn-outline-dark"
            onClick={handlePrev}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages}
            <br />
            (count {data.length})
          </span>
          <div className="d-flex">
            <button
              className="btn btn-sm btn-outline-dark me-1"
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
            <DownloadExcel
              tableRef={tableRef}
              fileName={`Day wise path wastage`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DayWisePath;
